<template>
  <div class="setting-auto-flow-table-wrapper">
    <table class="disp-scroll">
      <thead>
        <tr>
          <th>曜日</th>
          <th>停止開始時間</th>
          <th>停止終了時間</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <!-- 停止曜日 -->
          <td>
            <select
              class="select is-small"
              v-model="daysWeekSelected"
            >
              <option :value="day" v-for="(day) in pauseDaysWeek" :key="day">
                {{ day }}
              </option>
            </select>
          </td>
          <!-- 停止開始時間 -->
          <td>
            <input type="time" style="" v-model="pauseAutoFLowStartTimeInput"/>
          </td>
          <!-- アクション対象 -->
          <td>
            <input type="time" style="" v-model="pauseAutoFLowEndTimeInput"/>
          </td>
          <!-- ボタン -->
          <td>
            <button
              @click="register"
              class="button is-small is-primary"
            >
              登録
            </button>
          </td>
        </tr>
        <tr v-for="(setting, i) in pauseAutoFlowSettingList" :key="i">
          <td>
            {{ setting.day_week }}
          </td>
          <td>
            {{ setting.start_time.slice(0,-3) }}
          </td>
          <template>
            <td >
              {{ setting.end_time.slice(0,-3) }}
            </td>
            <td>
              <button @click="deleteFlow(setting)" class="button is-small is-danger">削除</button>
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  props: {
    createPauseAutoFlowSetting: {
      type: Function,
      required: true,
      default: () => null,
    },
    deletePauseAutoFlowSetting: {
      type: Function,
      required: true,
      default: () => null,
    },
    pauseDaysWeek: {
      required: true,
    },
    pauseAutoFlowSettingList: {
      type: Array,
      required: true,
      default: () => [],
    }
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
  },
  data() {
    return {
      daysWeekSelected: "月曜日",
      pauseAutoFLowStartTimeInput: "00:00",
      pauseAutoFLowEndTimeInput: "00:00",
      errormessage: ""
    }
  },
  methods: {
    register() {
      if(!this.checkInput()) {
        alert(this.errormessage)
        return false
      }
      // 停止終了時間の分で59分がセットされている場合は、ぎりぎりまでを想定していると思われるため、59秒まで設定する
      let modifiedPauseAutoFlowEndTimeInput = this.pauseAutoFLowEndTimeInput
      if(this.pauseAutoFLowEndTimeInput.slice(-2) == '59') {
        modifiedPauseAutoFlowEndTimeInput = modifiedPauseAutoFlowEndTimeInput+":59"
      }
      this.sendControlLog('自動採用フロー停止設定追加', '採用フロー停止設定にて、「登録」ボタンをクリックした。')
      this.createPauseAutoFlowSetting(
        this.daysWeekSelected,
        this.pauseAutoFLowStartTimeInput,
        modifiedPauseAutoFlowEndTimeInput
      )
    },
    deleteFlow(setting) {
      this.sendControlLog('自動採用フロー停止設定削除', '採用フロー停止設定にて、「削除」ボタンをクリックした。\n削除確認にてキャンセルされた場合は、削除されなかった可能性があります。')
      this.deletePauseAutoFlowSetting(setting.id)
    },
    checkInput() {
      if(this.pauseAutoFLowEndTimeInput == "" || this.pauseAutoFLowEndTimeInput == null) {
        this.pauseAutoFLowEndTimeInput = '23:59'
      }
      if(this.pauseAutoFLowStartTimeInput == "" || this.pauseAutoFLowStartTimeInput == null) {
        this.pauseAutoFLowStartTimeInput = '00:00'
      }
      // 一部input type="time"が効かないブラウザがあるため、その対応
      // 正規表現フォーマットのregexを開始時間と終了時間で利用しようとしたが、
      // うまく動かなかったため、別でregex2というフォーマットの変数を作成。
      const regex = /^([01][0-9]|2[0-3]):[0-5][0-9]$/g
      if (!regex.test(this.pauseAutoFLowStartTimeInput)) {
        this.errormessage = '開始時間は「時:分」形式で入力してください'
        return false
      }
      const regex2 = /^([01][0-9]|2[0-3]):[0-5][0-9]$/g
      if (!regex2.test(this.pauseAutoFLowEndTimeInput)) {
        this.errormessage = '終了時間は「時:分」形式で入力してください'
        return false
      }

      let checkEndTime = parseInt(this.pauseAutoFLowEndTimeInput.replace(":",""))
      let checkStartTime = parseInt(this.pauseAutoFLowStartTimeInput.replace(":",""))
      if(checkEndTime <= checkStartTime) {
        this.errormessage = '終了時間を開始時間よりも遅く設定してください'
        return false
      }
      return true
    }
  },
}
</script>

<style lang="scss" scoped>
.setting-auto-flow-table-wrapper {
  display: flex;
  justify-content: center;
  table td:not([align]),
  table th:not([align]) {
    text-align: center;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0 auto;
    display: block;
    //overflow: auto;
    table-layout: fixed;
  }
  table::-webkit-scrollbar {
    //width: 5px;
    //height: 5px;
    //visibility: hidden;
  }
  tr {
    width: 100%;
  }
  td,
  th {
    padding: 8px;
    margin: auto;
    font-size: smaller;
    border-style: solid;
    border-width: 1px;
    border-color: black;
  }
  td {
    text-align: left;
    vertical-align: middle;
    overflow: scroll;
    padding: 8px;
  }
  td > div::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    visibility: hidden;
  }
  th {
    color: #fff;
    background: #aa0066;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 10000;
  }
  table tr:nth-child(odd) {
    background: #ffeeff;
  }
  table tr:nth-child(even) {
    background: #fafafa;
  }
  .select-action {
    color: blue;
    cursor: pointer;
  }
  .select-target {
    width: auto;
    font-size: 13.33px;
    background-color: white;
    /deep/ .vs__selected-options {
      flex-wrap: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/tables/SettingPauseAutoFlowTable.vue